export default "__VITE_ASSET__BGfBkKsk__"